import { render, staticRenderFns } from "./Noticeread.vue?vue&type=template&id=5e303127&scoped=true&"
import script from "./Noticeread.vue?vue&type=script&lang=js&"
export * from "./Noticeread.vue?vue&type=script&lang=js&"
import style0 from "./Noticeread.vue?vue&type=style&index=0&id=5e303127&prod&scoped=true&lang=css&"
import style1 from "./Noticeread.vue?vue&type=style&index=1&id=5e303127&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e303127",
  null
  
)

export default component.exports